import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { CrntIcon } from '@essent/current-web-angular';

@Component({
  selector: 'wl-commodity-usp-list',
  templateUrl: './commodity-usp-list.component.html',
  styleUrls: [],
  standalone: true,
  imports: [CommonModule, CSCaptureDirective, CrntIcon],
})
export class CommodityOfferUspListComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) usps!: string[];
}
